import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import SettingsIcon from "@material-ui/icons/Settings";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import PracticeSettings from "views/Components/PracticeSettings.jsx"
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

const style = {
  dialogPaper: {
    minHeight: '60vh',
    maxHeight: '80vh',
  },
  ...userProfileStyles
};

class Settings extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      userId: sessionStorage.getItem('userId'),
      userUuid: sessionStorage.getItem('userUuid')
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>





        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <SettingsIcon />
            </CardIcon>
            <h4 id="organizationProvidersHeader" className={classes.cardIconTitle}>
              Settings
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>

              <PracticeSettings
                providerId = {this.state.userId}
                providerUuid = {this.state.userUuid}
                includeUpdateButton = {true}
                getCurrentSettings = {true}
              />
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader color="cirrusBlue" icon>
            <CardIcon color="cirrusBlue">
              <SettingsIcon />
            </CardIcon>
            <h4 id="organizationProvidersHeader" className={classes.cardIconTitle}>
              Logo
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>

              <ImageUpload
                userId = {this.state.userId}
              />
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    )

  }


}

export default withStyles(style)(Settings);